import { graphClient } from "../graph-client";
import { CREATE_AGENCY_SALE_DETAIL } from "./gql";
import { Create } from "./types";

export class AgencySaleDetail {
  async create(params: Create.Input) {
    const request = await graphClient.request<Create.Output>(
      CREATE_AGENCY_SALE_DETAIL,
      {
        ...params,
      }
    );

    return request?.createAgencySaleDetail;
  }
}

export const agencySaleDetail = new AgencySaleDetail();
